import type { APPLICANT_ATTRIBUTION_BOTH_TYPE, LOAN_REQUEST_COMMAND } from 'cpool-constants';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { LoanFormLayout } from './LoanFormLayout';
import { RefinanceFields } from './RefinanceFields';
import { useIsLoanFormDisabled } from './useIsLoanFormDisabled';
import type { SchemaCreditRequestForm } from '../../../schemas/creditRequestForm.schema';
import { type CreditLineLoanType, KONTOKORRENTKREDIT } from '../../../types';
import { FormCurrencyInput } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormCurrencyInput';
import { FormPercentInput } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormPercentInput';
import { FormTextInput } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormTextInput';

type Props = {
    type: CreditLineLoanType;
    index: number;
    applicant: APPLICANT_ATTRIBUTION_BOTH_TYPE;
    commandName: LOAN_REQUEST_COMMAND;
};

export const CreditLineLoanFields: React.FC<Props> = ({ applicant, commandName, index, type }) => {
    const { t } = useTranslation();
    const disabled = useIsLoanFormDisabled({ applicant, commandName });
    const { control } = useFormContext<SchemaCreditRequestForm>();

    return (
        <LoanFormLayout
            name={`${type}.${index}`}
            disabled={disabled}
            left={
                <>
                    <FormCurrencyInput
                        control={control}
                        id={`${type}.${index}.verfuegungsrahmen`}
                        label={t('EXISTING_LOANS.LOAN_FRAME')}
                        disabled={disabled}
                    />
                    <FormCurrencyInput
                        control={control}
                        id={`${type}.${index}.beanspruchterBetrag`}
                        label={t('EXISTING_LOANS.LOAN_USED_AMOUNT')}
                        disabled={disabled}
                    />
                    <FormPercentInput
                        control={control}
                        id={`${type}.${index}.zinssatz`}
                        label={t('EXISTING_LOANS.LOAN_INTEREST')}
                        allowDecimals
                        disabled={disabled}
                    />
                </>
            }
            right={
                type === KONTOKORRENTKREDIT ? (
                    <FormTextInput
                        control={control}
                        id={`${type}.${index}.glaeubiger`}
                        label={t('EXISTING_LOANS.LOAN_CREDITOR')}
                        disabled={disabled}
                    />
                ) : (
                    <RefinanceFields name={`${type}.${index}`} disabled={disabled} />
                )
            }
        />
    );
};
